import { render, staticRenderFns } from "./ListHistoryFiatRate.vue?vue&type=template&id=4729a220&"
import script from "./ListHistoryFiatRate.vue?vue&type=script&lang=js&"
export * from "./ListHistoryFiatRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports